module.exports = __webpack_public_path__ + "img/913.f94592f1.png";